module.exports = __webpack_public_path__ + "img/shipin.1e34d1a6.png";